export default {
  edit: "fas fa-edit",
  add: "fas fa-plus",
  copy: "fas fa-copy",
  delete: "fas fa-trash",
  toggleUp: "fas fa-angle-up",
  toggleDown: "fas fa-angle-down",
  back: "fas fa-arrow-left",
  prev: "fas fa-chevron-left",
  next: "fas fa-chevron-right",
  cog: "fas fa-cog",
  book: "fas fa-book",
  user: "fas fa-user",
  arrowLeft: "fas fa-arrow-left",
  share:"fas fa-share-alt",
  export: "fas fa-file-export",
  info: "fas fa-question-circle",
  demographicinformation: "fas fa-id-card",
  contactinformation: 'fas fa-address-book',
  reproductivehealth: 'fas fa-baby',
  presentingcomplaint: 'fas fa-comment-medical',
  vitalsignsandmeasurements: 'fas fa-heartbeat',
  physicalexamination: 'fas fa-stethoscope',
  medicalhistory: 'fas fa-notes-medical',
  familyhistory: 'fas fa-dna',
  socialhistory: 'fas fa-users',
  allergies: 'fas fa-allergies',
  immunizationhistory: 'fas fa-syringe',
  medications: 'fas fa-prescription-bottle',
  laboratorytestshematology: 'fas fa-vial',
  laboratorytestsbiochemistry: 'fas fa-flask',
  laboratorytestsurinalysis: 'fas fa-prescription-bottle',
  imaging: 'fas fa-x-ray',
  diagnosis: 'fas fa-diagnoses',
  treatmentplan: 'fas fa-briefcase-medical',
  adverseevents: 'fas fa-exclamation-triangle',
  outcomeandfollowup: 'fas fa-clipboard-check',
  additionalinformation: 'fas fa-comment-dots',
  clock: "fas fa-clock",
  paperclip: 'fas fa-paperclip',
  link: 'fas fa-link',
  trash: 'fas fa-trash',
  infoCircle:     "fas fa-info-circle",
  minus:          "fas fa-minus",
  pen:            "fas fa-pen",
  cogs:           "fas fa-cogs",
  exchangeAlt:    "fas fa-exchange-alt",
  toggleOn:       "fas fa-toggle-on",
  toggleOff:      "fas fa-toggle-off",
  check:          "fas fa-check",
  times:          "fas fa-times",
  ellipsis : "fas fa-ellipsis-v",
  move: "fas fa-grip-vertical",
  chevronLeft: "fas fa-angle-double-left",
  chevronRight: "fas fa-angle-double-right",
  expand: "fas fa-expand",
  compress: "fas fa-compress"


};